@use '@snowit/style/mixins';

// Overlay
.overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-index-top);
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 1rem;
  background: var(--modal-overlay);

  @include mixins.media(sm) {
    padding: 2.5rem;
  }
}

// Modal
.modal {
  position: relative;
  z-index: var(--z-index-top);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(3.5rem, auto) 1fr 5rem;
  grid-template-areas: 'header' 'body' 'footer';
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: var(--s-sm) var(--s-sm) 0 0;
  background: var(--c-modal-bg);
  box-shadow: var(--sw-dp16);

  @include mixins.media(sm) {
    height: auto;
    max-height: 100%;
    border-radius: var(--s-df);
  }
}

.modal:focus-visible {
  outline: none;
}

// Header
.header {
  display: grid;
  grid-template-columns: 2rem 2fr 2rem;
  grid-template-areas: 'other content close';
  column-gap: 0.5rem;
  grid-area: header;
  align-items: center;
  padding: 0.5rem 1.5rem;
  box-shadow: var(--sw-inset-bottom);
}

.contentHeader {
  display: flex;
  grid-area: content;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.close {
  grid-area: close;
  justify-self: end;
}

.otherAction {
  grid-area: other;
  justify-self: flex-start;
}

// Body
.body {
  display: flex;
  flex-direction: column;
  grid-area: body;
  padding: 1.5rem;

  @include mixins.overflowY;
}

.body:focus-visible {
  outline: none;
}

// Footer
.footer {
  display: flex;
  gap: 1rem;
  grid-area: footer;
  justify-content: flex-end;
  align-items: center;
  padding: 0 1.5rem;
  box-shadow: var(--sw-inset-top);
}

// If size 'df'
.df {
  .modal {
    @include mixins.media(sm) {
      width: 30rem;
    }
  }
}

// If size 'lg'
.lg {
  .modal {
    @include mixins.media(sm) {
      width: 42rem;
    }
  }
}

// If size 'sm'
.sm {
  .modal {
    @include mixins.media(sm) {
      width: 22rem;
    }
  }
}

// If size 'fullContent'
.fullContent {
  .modal {
    @include mixins.media(sm) {
      width: auto;
    }
  }
}

// If size 'fullPage'
.fullPage {
  padding: 0;

  .modal {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
  }
}

// If theme 'confirm' / 'error' / 'message'
.confirm,
.error,
.message {
  padding: 1.5rem;

  @include mixins.media(sm) {
    padding: 2.5rem;
  }

  .modal {
    grid-template-rows: minmax(3.5rem, auto) 1fr minmax(5rem, auto);
    height: auto;
    border-radius: var(--s-sm);
  }

  .header {
    box-shadow: none;
  }

  .contentHeader {
    justify-content: flex-start;
    margin-bottom: 1rem;
    text-align: initial;
  }

  .body {
    padding: 0 1.5rem 1.5rem;
  }
}

// If no header
.noHeader {
  .modal {
    grid-template-rows: 1fr minmax(0, 5rem);
    grid-template-areas: 'body' 'footer';
  }
}

// If no footer
.noFooter {
  .modal {
    grid-template-rows: minmax(3.5rem, auto) 1fr;
    grid-template-areas: 'header' 'body';
  }
}

// If only body
.onlyBody {
  .modal {
    grid-template-rows: 1fr;
    grid-template-areas: 'body';
  }
}

// If not padding body
.notPaddingBody {
  padding: 0;
}
